import React, { useEffect } from "react";

const UpgradeConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  plan,
  billingCycle,
  isLoading,
  isINR,
}) => {
  // Prevent body scroll when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }

    // Cleanup on unmount
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const price = isINR
    ? billingCycle === "monthly"
      ? plan.priceMonthlyIN
      : plan.priceAnnualIN
    : billingCycle === "monthly"
      ? plan.priceMonthly
      : plan.priceAnnual;

  return (
    <div className="fixed inset-0 bg-gray-900 bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg w-full max-w-md p-6 shadow-xl">
        {/* Header */}
        <div className="text-center mb-6">
          <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg
              className="w-8 h-8 text-primary"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"
              />
            </svg>
          </div>
          <h3 className="text-xl font-bold text-gray-900 mb-2">
            Confirm Plan Upgrade
          </h3>
          <p className="text-gray-600">
            Are you sure you want to upgrade to the {plan.name} plan?
          </p>
        </div>

        {/* Plan Details */}
        <div className="bg-gray-50 rounded-lg p-4 mb-6">
          <div className="flex justify-between items-center mb-2">
            <span className="text-gray-600 font-medium">Plan:</span>
            <span className="font-bold text-gray-900">{plan.name}</span>
          </div>
          <div className="flex justify-between items-center mb-2">
            <span className="text-gray-600 font-medium">Billing Cycle:</span>
            <span className="font-bold text-gray-900 capitalize">
              {billingCycle}
            </span>
          </div>
          <div className="flex justify-between items-center">
            <span className="text-gray-600 font-medium">Price:</span>
            <span className="font-bold text-primary">
              {isINR ? "₹" : "$"}
              {billingCycle === "monthly" ? price : price * 12}/
              {billingCycle === "monthly" ? "month" : "year"} per user
            </span>
          </div>
        </div>

        {/* Footer */}
        <div className="flex justify-end space-x-3">
          <button
            onClick={onClose}
            disabled={isLoading}
            className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            disabled={isLoading}
            className={`px-6 py-2 rounded-lg font-medium focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all duration-300 ${
              isLoading
                ? "bg-gray-400 text-gray-200 cursor-not-allowed"
                : "bg-yellow text-black hover:opacity-90"
            }`}
          >
            {isLoading ? (
              <div className="flex items-center space-x-2">
                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                <span>Upgrading...</span>
              </div>
            ) : (
              "Confirm Upgrade"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpgradeConfirmationModal;
